import { FormValidationService } from './form-validation-service'
import { Input, OnDestroy, Directive } from '@angular/core'
import { FieldValidator } from './field-validator'
import { settlePromises } from './settle-promises'

@Directive()
export abstract class Validatable<T> implements OnDestroy {
    @Input() disabled = false

    @Input() validators: FieldValidator<T>[] = []
    errorMessages: string[] = []

    abstract getValue(): T

    abstract getLabel(): string

    constructor(private formValidationService?: FormValidationService) {
        formValidationService?.subscribe(this)
    }

    ngOnDestroy(): void {
        this.formValidationService?.unsubscribe(this)
    }

    validate() {
        this.runValidations()
            .then(() => {})
            .catch(() => {})
    }

    clearValidationErrors() {
        this.errorMessages = []
    }

    runValidations(): Promise<undefined> {
        return new Promise((resolve, reject) => {
            if (this.disabled) {
                resolve(undefined)
                return
            }

            this.clearValidationErrors()

            settlePromises(this.validators.map((validator) => validator.validate(this.getValue(), this.getLabel())))
                .then(() => {
                    resolve(undefined)
                })
                .catch((errors) => {
                    this.errorMessages = errors
                    reject()
                })
        })
    }
}
